import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_NOTAS_BLOPED = 'ALL_NOTAS_BLOPED';
export const ACTIVO_NOTAS_BLOPED = 'ACTIVO_NOTAS_BLOPED';
export const LOADING_ALL_NOTAS_BLOPED = 'LOADING_ALL_NOTAS_BLOPED';
export const LOADING_PLANEVA = 'LOADING_PLANEVA';
export const PARAMS_NOTAS_BLOPED = 'PARAMS_NOTAS_BLOPED';
export const PLANEVA_NOTAS_BLOPED = 'PLANEVA_NOTAS_BLOPED';
export const ALL_ESTUDIANTES_PLAN_NOTAS_BLOPED =
  'ALL_ESTUDIANTES_PLAN_NOTAS_BLOPED';
export const IS_DISABLED_DATA = 'IS_DISABLED_DATA';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  loadingPlanEva: false,
  planEvaluacion: null,
  params: {
    idEntidad: null,
    idPeriodoAcademico: null,
    idDocente: null,
    idBloquePedagogico: null,
    idMateria: null,
    idSeccion: null,
  },
  allEstudiantesPlan: [],
  isDisabledData: false,
};

export const notasBlopedReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_NOTAS_BLOPED:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_NOTAS_BLOPED:
      return {
        ...state,
        activo: action.payload,
      };
    case PLANEVA_NOTAS_BLOPED:
      return {
        ...state,
        planEvaluacion: action.payload,
      };
    case LOADING_ALL_NOTAS_BLOPED:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case LOADING_PLANEVA:
      return {
        ...state,
        loadingPlanEva: action.payload,
      };
    case PARAMS_NOTAS_BLOPED:
      return {
        ...state,
        params: action.payload,
      };
    case ALL_ESTUDIANTES_PLAN_NOTAS_BLOPED:
      return {
        ...state,
        allEstudiantesPlan: action.payload,
      };
    case IS_DISABLED_DATA:
      return {
        ...state,
        isDisabledData: action.payload,
      };

    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
